<template>
    <v-card
            class="px-3 primary_bg_color"
            transparent
            outlined
    >
        <v-row>
            <v-col cols="7">
                <v-btn-toggle
                        v-model="cutType"
                        dense
                        background-color="primary"
                        class="change_dtype mb-3"
                >
                    <v-btn v-for="(item,index) in cutTypeList" :key="index">
                        <span class="hidden-sm-and-down">{{item}}</span>
                    </v-btn>

                </v-btn-toggle>
                <choiseCut v-model="cutType"/>
            </v-col>
            <v-col>
                <v-row>
                    <v-col style="position: relative">
                        <span class="legend-height">Высота {{heightTemp>0?heightTemp:''}}</span>
                        <span class="legend-width">Ширина {{widthTemp>0?widthTemp:''}}</span>
                        <svg :id="'svg-' + side" width="156" height="166" style="background-color: whitesmoke;" class="cutSelect">
                            <rect id="rect" x="0" :y="166-height*pxRatio" :width="width+'mm'" :height="height+'mm'" style="fill:#D8D8D8; stroke: darkgray;"></rect>

                        </svg>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <span class="body-2 font-weight-light">
                            Высота
                        </span>
                        <v-btn @click="height==0?'':height--" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                        {{ height }} mm
                        <v-btn @click="height++" data-test-id="addHeight" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn>
                    </v-col>
                    <v-col class="mt-0">
                        <span class="body-2 font-weight-light">
                            Ширина
                        </span>
                        <v-btn @click="width==0?'':width--" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                        {{ width }} mm
                        <v-btn @click="width++" data-test-id="addWidth" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
    import choiseCut from './ChoiseCut'
    export default {
        name: 'wheelDamage',
        props: ['side'],
        components: {
            choiseCut,
        },
        data() {
            return {
                pxRatio: null,
                widthTemp: 0,
                heightTemp: 0,
            }
        },
        computed: {
            cutTypeList () {
                return this.$store.state.repair['cutTypeList']
            },
            cutType: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.cutType
                },
                set(value) {
                    this.$store.commit('repair/setCutType', { side: this.side, value })
                }
            },
            width: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.cutWidth
                },
                set(value) {
                    this.$store.commit('repair/setCutWidth', { side: this.side, value })
                }
            },
            height: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.cutHeight
                },
                set(value) {
                    this.$store.commit('repair/setCutHeight', { side: this.side, value })
                }
            },
        },
        mounted() {
            this.pxRatio = this.xToPx('1mm')
            const svg = document.querySelector('#svg-' + this.side);
            // const rect = document.querySelector('#rect');
            svg.addEventListener('click',(e) => {
                var pt = svg.createSVGPoint(), svgP;
                pt.x = e.clientX;
                pt.y = e.clientY;
                svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
                this.width=Math.round(svgP.x/this.pxRatio)
                this.height=Math.round((166-svgP.y)/this.pxRatio)
            }, false);
            svg.addEventListener('mousemove',(e) => {
                var pt = svg.createSVGPoint(), svgP;
                pt.x = e.clientX;
                pt.y = e.clientY;
                svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
                this.widthTemp=Math.round(svgP.x/this.pxRatio)
                this.heightTemp=Math.round((166-svgP.y)/this.pxRatio)
            }, false);
            svg.addEventListener('mouseleave',() => {
                this.widthTemp=0
                this.heightTemp=0
            }, false);
        },
        methods: {
            xToPx(x) {
                var div = document.createElement('div');
                div.style.display = 'block';
                div.style.height = x;
                document.body.appendChild(div);
                var px = parseFloat(window.getComputedStyle(div, null).height);
                div.parentNode.removeChild(div);
                return px;
            },
        }
    }
</script>
<style lang="scss">
    .legend-height {
        color: cadetblue;
        position: absolute;
        transform-origin: 0 0;
        transform: rotate(-90deg);
        /* Legacy vendor prefixes that you probably don't need... */
        /* Safari */
        -webkit-transform: rotate(-90deg);
        /* Firefox */
        -moz-transform: rotate(-90deg);
        /* IE */
        -ms-transform: rotate(-90deg);
        /* Opera */
        -o-transform: rotate(-90deg);
        left:-10px;
        bottom: 0px;
    }
    .legend-width {
        color: cadetblue;
        position: absolute;
        bottom: -11px;
    }
    .cutSelect{
        cursor: crosshair;
    }
    .change_dtype.active {
        background-color: #FFFBCD !important;
    }
</style>
